import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../../AppContext';
import './PasswordCheck.css';

export default function PasswordCheck() {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const { setCurrentStep } = useContext(AppContext);
    const [error, setError] = useState('');
    const hardcodedPassword ='Test';

    const handleInputChange = (e) => {
        setPassword(e.target.value);
        setError('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!password) {
            setError('Please enter a valid password.');
            return;
        }

        if (password !== hardcodedPassword) {
            setError('Wrong Password.');
            return;
        }

        setError('');
        setCurrentStep(7);
        navigate('/emailSearch');
    };

    return (
        <div className="password-check-container">
            <h2>Login</h2>
            <form onSubmit={handleSubmit} className="password-check-form">
                <div className="input-group">
                    <label htmlFor="password">Password</label>
                    <input
                        placeholder="Enter Password"
                        type="password"
                        id="password"
                        value={password}
                        onChange={handleInputChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit(e);
                            }
                        }}
                    />
                    {error && <p className="text-danger">{error}</p>}
                </div>
                <button type="submit" className="submit-btn">Submit</button>
            </form>
        </div>
    );
}
